import React from "react";
import ExperienceStyles from "./Experience.module.css";
import { Element } from "react-scroll";

const Experience = () => {
  return (
    <Element name="experience">
      <h2 className={ExperienceStyles.title}>Experience</h2>
      <section className={ExperienceStyles.ExperienceContainer}>
        <div className={ExperienceStyles.ExperienceData}>
          <h2>Technical Mentor</h2>
          <h6>
            I have been mentoring students in Python programming, utilizing
            interactive animations and hands-on practice to impart core Python
            concepts and skills
          </h6>
          <h5>NOV 2022 - <span>PRESENT</span></h5>
        </div>
        <div className={ExperienceStyles.ExperienceData}>
          <h2>IBM Internship</h2>
          <h6>
            Collabrated with IBM and a four-member team to analyze COVID-19 data
            in the Hospital Healthcare Domain in my final year of engineering.
            Leveraged data analytics to identify patient Length of Stay trends,
            providing insights to assist hospitals in resource planning and
            enhanced patient care with focus on outcomes and costs
          </h6>
          <h5>NOV 2022 - <span>FEB 2023</span></h5>
        </div>
        {/* <div className={ExperienceStyles.ExperienceData}>
          <h2>Cognizant Virtual Internship</h2>
          <h6>
            Completed a job simulation focused on AI for Cognizant’s Data
            Science team. Conducted exploratory data analysis using Python and
            Google Colab for one of Cognizant’s technology-led clients, Gala
            Groceries.Prepare a Python module that contains code to train a
            model and output the performance metrics for the Machine Learning
            engineering team. Communicated findings and analysis in the form of
            a PowerPoint slide to present the results back to the business.
          </h6>
          <h5>NOV 2023 - <span>DEC 2023</span></h5>
        </div>
        <div className={ExperienceStyles.ExperienceData}>
          <h2>British Airways Virtual Internship</h2>
          <h6>
            Completed a simulation focussing on how data science is a critical
            component of British Airways success Scraped and analysed customer
            review data to uncover findings Built a predictive model to
            understand factors that influence buying behaviour
          </h6>
          <h5>NOV 2023 - <span>DEC 2023</span></h5>
        </div> */}
      </section>
      </Element>
  );
};

export default Experience;
